import Annotations from "./Annotations";
import GuidedHighlighting from "./GuidedHighlighting";
import HighlightingPlugin from "./HighlightingPlugin";

export * from "./TextHighlighting.interface";
export * from "./TextHighlighting.style";

export { Annotations, GuidedHighlighting, HighlightingPlugin };
